import React from "react";

export default function Navbar(){
    return(
        <div className="navbar">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Apple_logo_dark_grey.svg/800px-Apple_logo_dark_grey.svg.png" alt="logo"/>
            <h1>iCloud</h1>
        </div>
    )
}